import { css } from "@emotion/react";

import { colors } from "../../../styles";

export const teamMember = css`
  background-color: ${colors.softWhite};
  min-height: 80vh;
`;

export const teamMemberInfo = css`
  padding-top: 60px;
  padding-bottom: 60px;
  display: flex;
  max-width: 75rem;
  margin-left: auto;
  margin-right: auto;
  flex-wrap: wrap;
  justify-content: space-evenly;
`;

export const personalInfo = css`
  margin-left: 2rem;
  margin-top: 2rem;
`;

export const img = css`
  border-radius: 50%;
  height: 400px;
  width: 400px;
  object-fit: cover;

  @media only screen and (max-width: 64em) {
    height: 300px;
    width: 300px;
  }
`;

export const name = css`
  font-size: 3.1rem;
`;

export const h2 = css`
  font-size: 1.6rem;
  color: ${colors.gray};
  margin-bottom: 0;
`;

export const contactInfo = css`
  margin-top: 0;
`;

export const aboutContainer = css`
  * {
    margin: 0;
  }
`;

export const editButton = css`
  cursor: pointer;
`;

export const actionButtonsContainer = css`
  margin-top: 1rem;
  display: flex;
  gap: 1rem;
`;
